import { ScaleLine } from "ol/control";
import type { Options as ScaleLineOptions } from "ol/control/ScaleLine";
import { useCallback } from "react";

import { OlControl } from "./OlControl";

export interface ScaleLineControlProps {
  order?: number;
  scaleOptions?: ScaleLineOptions;
}

export function ScaleLineControl({
  order,
  scaleOptions,
}: ScaleLineControlProps) {
  const ctor = useCallback(
    (target: HTMLElement) => {
      return new ScaleLine({
        minWidth: 48,
        ...scaleOptions,
        target,
      });
    },
    [scaleOptions],
  );

  return (
    <OlControl className="map-scale-line-control" ctor={ctor} order={order} />
  );
}
